export class KioskMeasurementViewModel {

    kioskId: string;
    tenantId: string;
    status: string;
    batteryVoltage: number;
    temperature: number;
    created: Date;
    localTimeStamp: Date;
    timezoneOffset: number;
    timeZone: string;
}